import { DateTimeViewer, GetDefaultIndexWithCollect } from "../../components";
import { useGetCompanyShareholdersCommonInfoQuery, useCollectCompanyShareholdersMutation } from "../../features/board/boardSlice";
import { useCompanyShareholderRoutes } from "./routes";
import { CompanyShareholderCollector } from "./companyShareholderCollector";
import { EntityCommonInfoModel } from "../../entities/common";
import { Descriptions } from "antd";

export { useCompanyShareholderRoutes };

export default GetDefaultIndexWithCollect({
  title: "سهامداران شرکت ها",
  query: useGetCompanyShareholdersCommonInfoQuery,
  collectMutation: useCollectCompanyShareholdersMutation,
  collector: (collectCallback) => <CompanyShareholderCollector collectCallback={collectCallback} />,
  generalInfoPresentor: (info: EntityCommonInfoModel) =>
    info ? (
      <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}>
        <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
          {info.totalRecords}
        </Descriptions.Item>
        <Descriptions.Item label="آخرین اطلاعات" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastCreateAt} mode="date" />
        </Descriptions.Item>
      </Descriptions>
    ) : null,
});
